/**
* 左边菜单
*/
<template>
	<el-menu default-active="2" :collapse="collapsed" collapse-transition router :default-active="$route.path"
		unique-opened class="el-menu-vertical-demo" background-color="#334157" text-color="#fff"
		active-text-color="#ffd04b">
		<div class="logobox">
			<img class="logoimg" :src="left.type?'':left.icon">
			<div class="tname">{{left.tname}}</div>
		</div>
		<el-submenu v-for="menu in allmenu" :key="menu.menuid" :index="menu.menuname">
			<template slot="title">
				<i class="iconfont" :class="menu.icon"></i>
				<span>{{menu.menuname}}</span>
			</template>
			<el-menu-item-group>
				<el-menu-item v-for="chmenu in menu.menus" :index="'/'+chmenu.url" :key="chmenu.menuid">
					<i class="iconfont" :class="chmenu.icon"></i>
					<span>{{chmenu.menuname}}</span>
				</el-menu-item>
			</el-menu-item-group>
		</el-submenu>
	</el-menu>
</template>
<script>
	import {
		menu
	} from '../api/userMG'
	export default {
		name: 'leftnav',
		data() {
			return {
				collapsed: false,
				allmenu: [],
				left: {}
			}
		},
		// 创建完毕状态(里面是操作)
		created() {
			this.left = JSON.parse(localStorage.getItem('userInfo'))
			console.log(this.left.type, 7888)
			switch (this.left.type) {
				case '0':
					this.allmenu = [{
							menuid: 1,
							icon: 'li-icon-xiangmuguanli',
							menuname: '基础管理',
							hasThird: null,
							url: null,
							menus: [{
									menuid: 2,
									icon: 'icon-cat-skuQuery',
									menuname: '数据大厅',
									hasThird: 'N',
									url: 'school/statistics',
									menus: null
								}, {
									menuid: 4,
									icon: 'icon-cus-manage',
									menuname: '用户管理',
									hasThird: 'N',
									url: 'school/user',
									menus: null
								},
								{
									menuid: 5,
									icon: 'icon-news-manage',
									menuname: '结算管理',
									hasThird: 'N',
									url: 'school/Role',
									menus: null
								}
							]
						}, {
							menuid: 18,
							icon: 'li-icon-xiangmuguanli',
							menuname: '活动通知',
							hasThird: null,
							url: null,
							menus: [{
								menuid: 3,
								icon: 'icon-cat-skuQuery',
								menuname: '首页通知',
								hasThird: 'N',
								url: 'school/infoSet',
								menus: null
							}, {
								menuid: 36,
								icon: 'icon-cat-skuQuery',
								menuname: '活动管理',
								hasThird: 'N',
								url: 'school/eventManagement',
								menus: null
							}]
						},
						{
							menuid: 6,
							icon: 'li-icon-dingdanguanli',
							menuname: '任务监管',
							hasThird: null,
							url: null,
							menus: [{
									menuid: 7,
									icon: 'icon-order-manage',
									menuname: '进行中',
									hasThird: 'N',
									url: 'school/working',
									menus: null
								},
								{
									menuid: 8,
									icon: 'icon-order-manage',
									menuname: '已完成',
									hasThird: 'N',
									url: 'school/worked',
									menus: null
								}
							]
						},
						{
							menuid: 9,
							icon: 'li-icon-xitongguanli',
							menuname: '学生管理',
							hasThird: null,
							url: null,
							menus: [{
									menuid: 10,
									icon: 'icon-cms-manage',
									menuname: '查看学生',
									hasThird: 'N',
									url: 'school/students',
									menus: null
								},
								{
									menuid: 11,
									icon: 'icon-promotion-manage',
									menuname: '班级管理',
									hasThird: 'N',
									url: 'school/class',
									menus: null
								},
								{
									menuid: 12,
									icon: 'icon-promotion-manage',
									menuname: '证书统计',
									hasThird: 'N',
									url: 'school/certificate',
									menus: null
								}
							]
						},
						{
							menuid: 11,
							icon: 'li-icon-xitongguanli',
							menuname: '企业管理',
							hasThird: null,
							url: null,
							menus: [{
									menuid: 31,
									icon: 'icon-cms-manage',
									menuname: '企业查询',
									hasThird: 'N',
									url: 'school/enterpriseInquiry',
									menus: null
								},
								{
									menuid: 33,
									icon: 'icon-promotion-manage',
									menuname: '工作审核',
									hasThird: 'N',
									url: 'school/certificate',
									menus: null
								}
							]
						}
					]
					break
				case '1':
					this.allmenu = [{
							menuid: 1,
							icon: 'li-icon-xiangmuguanli',
							menuname: '基础管理',
							hasThird: null,
							url: null,
							menus: [{
									menuid: 2,
									icon: 'icon-cat-skuQuery',
									menuname: '数据大厅',
									hasThird: 'N',
									url: 'company/statistics',
									menus: null
								},
								{
									menuid: 3,
									icon: 'icon-cat-skuQuery',
									menuname: '公司信息',
									hasThird: 'N',
									url: 'company/infoSet',
									menus: null
								}, {
									menuid: 4,
									icon: 'icon-cus-manage',
									menuname: '用户管理',
									hasThird: 'N',
									url: 'company/user',
									menus: null
								},
								{
									menuid: 5,
									icon: 'icon-news-manage',
									menuname: '账户管理',
									hasThird: 'N',
									url: 'company/Role',
									menus: null
								}
							]
						},
						{
							menuid: 3,
							icon: 'li-icon-xiangmuguanli',
							menuname: '信息查询',
							hasThird: null,
							url: null,
							menus: [{
									menuid: 21,
									icon: 'icon-cat-skuQuery',
									menuname: '学生信息',
									hasThird: 'N',
									url: 'company/studentsInfo',
									menus: null
								},
								{
									menuid: 22,
									icon: 'icon-cat-skuQuery',
									menuname: '任务核验',
									hasThird: 'N',
									url: 'company/workInfo',
									menus: null
								}
							]
						},
						{
							menuid: 6,
							icon: 'li-icon-dingdanguanli',
							menuname: '任务管理',
							hasThird: null,
							url: null,
							menus: [{
									menuid: 22,
									icon: 'icon-order-manage',
									menuname: '待审批',
									hasThird: 'N',
									url: 'company/pendingApproval',
									menus: null
								}, {
									menuid: 10,
									icon: 'icon-order-manage',
									menuname: '待上线',
									hasThird: 'N',
									url: 'company/pendingLaunch',
									menus: null
								}, {
									menuid: 7,
									icon: 'icon-order-manage',
									menuname: '招募中',
									hasThird: 'N',
									url: 'company/recruiting',
									menus: null
								},
								{
									menuid: 8,
									icon: 'icon-order-manage',
									menuname: '执行中',
									hasThird: 'N',
									url: 'company/working',
									menus: null
								},
								{
									menuid: 20,
									icon: 'icon-order-manage',
									menuname: '已完成',
									hasThird: 'N',
									url: 'company/worked',
									menus: null
								}
							]
						}
					]
					break
				case "2":
					this.allmenu = [{
							menuid: 1,
							icon: 'li-icon-xiangmuguanli',
							menuname: '基础管理',
							hasThird: null,
							url: null,
							menus: [{
									menuid: 2,
									icon: 'icon-cat-skuQuery',
									menuname: '数据大厅',
									hasThird: 'N',
									url: 'company/statistics',
									menus: null
								},
								{
									menuid: 3,
									icon: 'icon-cat-skuQuery',
									menuname: '赛事信息',
									hasThird: 'N',
									url: 'company/infoSet',
									menus: null
								}, {
									menuid: 4,
									icon: 'icon-cus-manage',
									menuname: '用户管理',
									hasThird: 'N',
									url: 'company/user',
									menus: null
								}
							]
						},
						{
							menuid: 3,
							icon: 'li-icon-xiangmuguanli',
							menuname: '信息查询',
							hasThird: null,
							url: null,
							menus: [{
									menuid: 21,
									icon: 'icon-cat-skuQuery',
									menuname: '学生信息',
									hasThird: 'N',
									url: 'company/studentsInfo',
									menus: null
								},
								{
									menuid: 22,
									icon: 'icon-cat-skuQuery',
									menuname: '教师信息',
									hasThird: 'N',
									url: 'company/workInfo',
									menus: null
								}
							]
						},
						{
							menuid: 6,
							icon: 'li-icon-dingdanguanli',
							menuname: '审核管理',
							hasThird: null,
							url: null,
							menus: [{
									menuid: 25,
									icon: 'icon-order-manage',
									menuname: '邀请码',
									hasThird: 'N',
									url: 'contest/pendingApproval',
									menus: null
								},
								{
									menuid: 26,
									icon: 'icon-order-manage',
									menuname: '教师认证',
									hasThird: 'N',
									url: 'contest/teacherCerApplication',
									menus: null
								}

							],

						}
					]
					break
				case '3':
					this.allmenu = [{
							menuid: 1,
							icon: 'li-icon-xiangmuguanli',
							menuname: '基础管理',
							hasThird: null,
							url: null,
							menus: [{
									menuid: 2,
									icon: 'icon-cat-skuQuery',
									menuname: '数据大厅',
									hasThird: 'N',
									url: 'company/statistics',
									menus: null
								},
								{
									menuid: 3,
									icon: 'icon-cat-skuQuery',
									menuname: '公司信息',
									hasThird: 'N',
									url: 'company/infoSet',
									menus: null
								}, {
									menuid: 4,
									icon: 'icon-cus-manage',
									menuname: '用户管理',
									hasThird: 'N',
									url: 'company/user',
									menus: null
								},
								{
									menuid: 5,
									icon: 'icon-news-manage',
									menuname: '账户管理',
									hasThird: 'N',
									url: 'company/Role',
									menus: null
								}
							]
						},
						{
							menuid: 3,
							icon: 'li-icon-xiangmuguanli',
							menuname: '信息查询',
							hasThird: null,
							url: null,
							menus: [{
									menuid: 21,
									icon: 'icon-cat-skuQuery',
									menuname: '学生信息',
									hasThird: 'N',
									url: 'company/studentsInfo',
									menus: null
								},
								{
									menuid: 22,
									icon: 'icon-cat-skuQuery',
									menuname: '任务核验',
									hasThird: 'N',
									url: 'company/workInfo',
									menus: null
								}
							]
						},
						{
							menuid: 6,
							icon: 'li-icon-dingdanguanli',
							menuname: '任务管理',
							hasThird: null,
							url: null,
							menus: [{
									menuid: 22,
									icon: 'icon-order-manage',
									menuname: '待审批',
									hasThird: 'N',
									url: 'company/pendingApproval',
									menus: null
								}, {
									menuid: 10,
									icon: 'icon-order-manage',
									menuname: '待上线',
									hasThird: 'N',
									url: 'company/pendingLaunch',
									menus: null
								}, {
									menuid: 7,
									icon: 'icon-order-manage',
									menuname: '招募中',
									hasThird: 'N',
									url: 'company/recruiting',
									menus: null
								},
								{
									menuid: 8,
									icon: 'icon-order-manage',
									menuname: '执行中',
									hasThird: 'N',
									url: 'company/working',
									menus: null
								},
								{
									menuid: 20,
									icon: 'icon-order-manage',
									menuname: '已完成',
									hasThird: 'N',
									url: 'company/worked',
									menus: null
								}
							]
						}
					]
					break
			}

		}
	}
</script>
<style>
	.el-menu-vertical-demo:not(.el-menu--collapse) {
		width: 240px;
		min-height: 400px;
		border: none;
		text-align: left;
	}

	.el-menu {
		border: none;
	}

	.logobox {
		height: 40px;
		line-height: 40px;
		text-align: center;
		padding: 20px 0px;
		display: flex;
	}

	.logoimg {
		height: 40px;
		margin: 0 10px;
	}

	.tname {
		font-size: 15px;
		font-weight: bold;
		color: #9d9d9d;
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
		width: 80%;
	}
</style>


// WEBPACK FOOTER //
// src/components/leftnav.vue